import { useContext, useRef } from 'react'

import { OptimizelyContext } from '@optimizely/react-sdk'

const RESUB_EXP_DISCOUNTS_IN_MENU_FLAG = 'winback_ofx_webclient_discounts_in_menu'

/**
 * Resub experiment gate: whether the xAPI fixed banner and basket label may be shown in the
 * Menu. The flag is decided only when there is content to show, and only once per mount, so
 * content that drops out while a category loads and comes back doesn't re-emit exposure.
 */
export const useResubExpDiscountsInMenu = (hasContent: boolean): boolean => {
  const { optimizely } = useContext(OptimizelyContext)
  const decisionRef = useRef<boolean>()

  if (optimizely && hasContent && decisionRef.current === undefined) {
    decisionRef.current = optimizely.decide(RESUB_EXP_DISCOUNTS_IN_MENU_FLAG).enabled
  }

  return hasContent && Boolean(decisionRef.current)
}
